// src/pages/SellerLogin.jsx
import React from "react";
import Login from "./Login";   // reuse existing seller login

export default function SellerLogin() {
  return <Login />;
}

